import { PageService } from '../page-service.js';
export class DocPageService extends PageService {
}
//# sourceMappingURL=doc-page-service.js.map